import React, { useCallback, useEffect } from 'react'
import { FiArrowRightCircle } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'

import Button from '../../components/Button'
import Header from '../../components/Header'

import Container from '../../components/Container'
import { Content } from './styles'

const Main: React.FC = () => {
  const history = useHistory()

  const handleStart = useCallback(async () => {
    // history.push('/start')
    // history.push('/auth')
    history.push('/register')
  }, [history])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <p>
            Olá,
            <br />
            Bem-vindo a BASF Previdência! Os próximos minutos terão alto impacto
            no seu planejamento pós carreira. Vamos juntos planejar seu futuro?
          </p>
          <Button
            color="orange"
            onClick={handleStart}
            width="large"
            fontSize="large"
          >
            <FiArrowRightCircle size={32} />
            Quero começar
          </Button>
          <small>
            O Plano BASF é um plano de previdência oferecido a todos os
            colaboradores efetivos do grupo BASF! Você contribui com uma parte e
            a empresa contribui com o mesmo valor, limitado as regras
            regulamentares. O objetivo principal é formar reserva para seu
            futuro e garantir maior segurança financeira! Um complemento de
            renda aos valores que serão recebidos pelo INSS.
          </small>
        </Content>
      </Container>
    </>
  )
}

export default Main
